
import { Client } from "../../types";
import { FieldIndicator } from "./FieldIndicator";

interface CoreInformationSectionProps {
  client: Client;
  fieldsWithNewData: Set<keyof Client>;
}

export const CoreInformationSection: React.FC<CoreInformationSectionProps> = ({ 
  client, 
  fieldsWithNewData 
}) => {
  return (
    <div>
      <h3 className="text-lg font-semibold mb-4 text-foreground">Core Information</h3>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <label className="text-sm font-medium text-muted-foreground">Industry</label>
          <div className="flex items-center">
            <p className="text-foreground">{client.industry || "Not specified"}</p>
            <FieldIndicator fieldName="industry" fieldsWithNewData={fieldsWithNewData} />
          </div>
        </div>
        
        <div>
          <label className="text-sm font-medium text-muted-foreground">Website</label>
          <div className="flex items-center">
            {client.website ? (
              <a 
                href={client.website.startsWith('http') ? client.website : `https://${client.website}`}
                target="_blank" 
                rel="noopener noreferrer"
                className="text-blue-600 hover:text-blue-800 dark:text-blue-400 dark:hover:text-blue-300"
              >
                {client.website}
              </a>
            ) : (
              <p className="text-foreground">Not specified</p>
            )}
            <FieldIndicator fieldName="website" fieldsWithNewData={fieldsWithNewData} />
          </div>
        </div>
        
        <div>
          <label className="text-sm font-medium text-muted-foreground">Address</label>
          <div className="flex items-center">
            <p className="text-foreground">{client.address || "Not specified"}</p>
            <FieldIndicator fieldName="address" fieldsWithNewData={fieldsWithNewData} />
          </div>
        </div>
        
        <div>
          <label className="text-sm font-medium text-muted-foreground">Headquarters</label>
          <div className="flex items-center">
            <p className="text-foreground">{client.headquarters_location || "Not specified"}</p>
            <FieldIndicator fieldName="headquarters_location" fieldsWithNewData={fieldsWithNewData} />
          </div>
        </div>
        
        <div>
          <label className="text-sm font-medium text-muted-foreground">Contact Phone</label>
          <div className="flex items-center">
            <p className="text-foreground">{client.contact_phone || "Not specified"}</p>
            <FieldIndicator fieldName="contact_phone" fieldsWithNewData={fieldsWithNewData} />
          </div>
        </div>
        
        <div>
          <label className="text-sm font-medium text-muted-foreground">Corporate Phone</label>
          <div className="flex items-center">
            <p className="text-foreground">{client.corporate_phone || "Not specified"}</p>
            <FieldIndicator fieldName="corporate_phone" fieldsWithNewData={fieldsWithNewData} />
          </div>
        </div>
        
        <div>
          <label className="text-sm font-medium text-muted-foreground">Contact Email</label>
          <div className="flex items-center">
            <p className="text-foreground">{client.contact_email || "Not specified"}</p>
            <FieldIndicator fieldName="contact_email" fieldsWithNewData={fieldsWithNewData} />
          </div>
        </div>
        
        <div>
          <label className="text-sm font-medium text-muted-foreground">Geographic Area</label>
          <div className="flex items-center">
            <p className="text-foreground">{client.geographic_area || "Not specified"}</p>
            <FieldIndicator fieldName="geographic_area" fieldsWithNewData={fieldsWithNewData} />
          </div>
        </div>
        
        <div>
          <label className="text-sm font-medium text-muted-foreground">Founded Year</label>
          <div className="flex items-center">
            <p className="text-foreground">{client.founded_year || "Not specified"}</p>
            <FieldIndicator fieldName="founded_year" fieldsWithNewData={fieldsWithNewData} />
          </div>
        </div>
        
        <div>
          <label className="text-sm font-medium text-muted-foreground">Status</label>
          <div className="flex items-center">
            <p className="text-foreground">{client.status || "Not specified"}</p>
            <FieldIndicator fieldName="status" fieldsWithNewData={fieldsWithNewData} />
          </div>
        </div>
        
        <div>
          <label className="text-sm font-medium text-muted-foreground">Notes</label>
          <div className="flex items-center">
            <p className="text-foreground">{client.notes || "No notes"}</p>
            <FieldIndicator fieldName="notes" fieldsWithNewData={fieldsWithNewData} />
          </div>
        </div>
      </div>
    </div>
  );
};
